import { CREATE_FOOTPRINT, CLEAR_FOOTPRINT } from './constants'

const initialState = {
  isFootprintSaving: false,
  footprintId: null
}

export default function contactOptionsReducer(state = initialState, action) {
  switch (action.type) {
    case CREATE_FOOTPRINT.REQUEST: {
      return {
        ...state,
        isFootprintSaving: true
      }
    }
    case CREATE_FOOTPRINT.SUCCESS: {
      return {
        ...state,
        isFootprintSaving: false,
        footprintId: action.footprint.footprintId
      }
    }
    case CLEAR_FOOTPRINT: {
      return {
        ...state,
        footprintId: null
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserEvents/reducer.js